module.exports = __webpack_public_path__ + "img/Line_icon.e82c294d.svg";